import React from 'react';
import { AlertMessage } from '../../../components/AlertMessage';

export function ConsentFieldAlert() {
  return (
    <div className='d-flex justify-content-center'>
      <AlertMessage
        icon={{ name: 'bi-info-circle' }}
        text='Candidate consent field is added to all Application Forms by default.'
        hasOverlay={false}
        className='mt-6 bg-light-info rounded align-self-start fs-5'
      />
    </div>
  );
}
